import { render } from "./PhotosPage.vue?vue&type=template&id=7b418a4a&scoped=true"
import script from "./PhotosPage.vue?vue&type=script&lang=js"
export * from "./PhotosPage.vue?vue&type=script&lang=js"

import "./PhotosPage.vue?vue&type=style&index=0&id=7b418a4a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b418a4a"]])

export default __exports__